import React, { useState } from 'react';
import { Tabs, Typography, Result, Skeleton } from 'antd';
import {
  AppstoreOutlined,
  TeamOutlined,
  ShoppingCartOutlined,
  SwapOutlined,
  ExperimentOutlined,
  FileTextOutlined,
  DollarOutlined,
  FireOutlined,
} from '@ant-design/icons';
import { useResponsive } from '../hooks/useResponsive';
import { useIsModuleEnabled } from '../hooks/useIsModuleEnabled';
import { MODULE_KEYS } from '../constants/moduleKeys';
import InventoryItemsTab from '../components/inventory/InventoryItemsTab';
import SuppliersTab from '../components/inventory/SuppliersTab';
import PurchaseOrdersTab from '../components/inventory/PurchaseOrdersTab';
import MovementsTab from '../components/inventory/MovementsTab';
import RecipesTab from '../components/inventory/RecipesTab';
import PreparationsTab from '../components/inventory/PreparationsTab';
import QuotationsTab from '../components/inventory/QuotationsTab';
import CostsTab from '../components/inventory/CostsTab';

const { Title } = Typography;

const Inventory: React.FC = () => {
  const [activeTab, setActiveTab] = useState('items');
  const { isMobile } = useResponsive();

  // Route guard — without it the sidebar gate is honor-only and a curious user could
  // land here by URL on a tenant where the module is off, triggering a barrage of
  // 403 toasts from the backend [RequireModule] filter on each tab's data fetch.
  const { enabled: isInventarioEnabled, isLoading: isLoadingSetting } = useIsModuleEnabled(MODULE_KEYS.Inventario);

  if (isLoadingSetting) {
    return <Skeleton active paragraph={{ rows: 8 }} />;
  }

  if (!isInventarioEnabled) {
    return (
      <Result
        status="403"
        title="Módulo de Inventario no habilitado"
        subTitle="Este restaurante no tiene activado el módulo. Contacta a soporte si quieres habilitarlo."
      />
    );
  }

  const tabItems = [
    {
      key: 'items',
      label: (
        <span>
          <AppstoreOutlined />
          {isMobile ? 'Insumos' : 'Insumos'}
        </span>
      ),
      children: <InventoryItemsTab />,
    },
    {
      key: 'suppliers',
      label: (
        <span>
          <TeamOutlined />
          {isMobile ? 'Proveed.' : 'Proveedores'}
        </span>
      ),
      children: <SuppliersTab />,
    },
    {
      key: 'purchase-orders',
      label: (
        <span>
          <ShoppingCartOutlined />
          {isMobile ? 'Órdenes' : 'Órdenes de Compra'}
        </span>
      ),
      children: <PurchaseOrdersTab />,
    },
    {
      key: 'movements',
      label: (
        <span>
          <SwapOutlined />
          {isMobile ? 'Movim.' : 'Movimientos'}
        </span>
      ),
      children: <MovementsTab />,
    },
    {
      key: 'recipes',
      label: (
        <span>
          <ExperimentOutlined />
          {isMobile ? 'Recetas' : 'Recetas'}
        </span>
      ),
      children: <RecipesTab />,
    },
    {
      key: 'preparations',
      label: (
        <span>
          <FireOutlined />
          {isMobile ? 'Prepar.' : 'Preparaciones'}
        </span>
      ),
      children: <PreparationsTab />,
    },
    {
      key: 'costs',
      label: (
        <span>
          <DollarOutlined />
          {isMobile ? 'Costos' : 'Costos'}
        </span>
      ),
      children: <CostsTab />,
    },
    {
      key: 'quotations',
      label: (
        <span>
          <FileTextOutlined />
          {isMobile ? 'Cotizac.' : 'Cotizaciones'}
        </span>
      ),
      children: <QuotationsTab />,
    },
  ];

  return (
    <div>
      <Title level={isMobile ? 4 : 3} style={{ marginBottom: isMobile ? 12 : 24 }}>
        Inventario
      </Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        tabBarStyle={{ marginBottom: isMobile ? 12 : 24 }}
        size={isMobile ? 'small' : 'middle'}
        tabBarGutter={isMobile ? 4 : undefined}
      />
    </div>
  );
};

export default Inventory;
